import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath, APIPathWithArguments } from 'src/js/api/route-path-index';
import { notificationHandler } from 'src/js/notification/notification-handler';

import { CertificateCa } from './certificates-models';
import { GenericDeleteModal } from 'src/js/component/generic-delete-modal';

interface Props {
  itemsToDelete: CertificateCa[];
  onSuccess: (deletedItems: CertificateCa[]) => void;
  onCancel?: VoidFunction;
}

export const CaDeleteModal: React.FunctionComponent<Props> = ({ itemsToDelete, onSuccess, onCancel }) => {
  const { t } = useTranslation();

  const handleDelete = (): Promise<any> => {
    let count = 0;
    return Promise.all(
      itemsToDelete.map((item, _index): Promise<any> => {
        const path = APIPathWithArguments(APIPath.ca.delete, { name: item.name });
        return apiClientWithoutHandler.genericController.delete(path).then((res: any) => {
          notificationHandler(res, null, t('security.certificates.notifications.deleteErrorMsg'), t);
          if (++count === itemsToDelete.length) {
            onSuccess(itemsToDelete); // this will close the modal in the parent
          }
          return res;
        });
      }),
    );
  };

  return (
    <GenericDeleteModal
      title={t('security.certificates.modal.delete.title', { count: itemsToDelete.length })}
      body={t('general.cannotUndo')}
      itemsToDelete={itemsToDelete}
      onCancel={onCancel}
      onDelete={handleDelete}
    />
  );
};
